<button
    type="button"
    class="btn btn-sm btn-transparent"
    (click)="sortLogs()"
    container="body"
    placement="bottom"
    tooltip="{{ 'Reverse sort direction' | translate }}">
    @if (isAscSort) {
        {{ 'Oldest first' | translate }}
    } @else {
        {{ 'Newest first' | translate }}
    }
    <i
        class="ms-1 fa-solid"
        [ngClass]="{
            'fa-arrow-down-wide-short': isAscSort,
            'fa-arrow-up-wide-short': !isAscSort,
        }"></i>
</button>

@for (logItem of ticketLog; track logItem.id) {
    <div class="panel-list-item flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
            <app-highlight-entity [entity]="logItem" [ticketId]="ticketId"></app-highlight-entity>
            <div tooltip="{{ logItem.time | date: 'dd.MM.yyyy HH:mm' }}" container="body">
                <small class="ms-1 text-light text-nowrap">
                    {{ logItem.time | ticketTime }}
                </small>
            </div>
        </div>
    </div>
}

@if (isLogLoading) {
    <sb-loader></sb-loader>
}

<div class="text-center pointer mb-2" [hidden]="isWholeLogLoaded || isLogLoading">
    <a (click)="loadLog()" translate>Load more</a>
</div>
